import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintbooks = () => {
  const title = "{BRAND.domainLabel} premiers alongside The Unfollow series of graphic novels at London Book Fair"

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on March, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                The London Book Fair 2025 saw {BRAND.domainLabel} unveiled to book
                lovers, alongside the launch of the Unfollow Series, from The
                Buddyhood.
              </p>

              <p>
                The event marked a key moment for both {BRAND.domainLabel} and The
                Buddyhood's Unfollow Series, celebrating a shared commitment to
                reimagining storytelling and reader engagement. Together, the
                two projects aim to build a community of changemakers, young
                people empowered to share their voices, explore complex ideas,
                and drive positive social impact.
              </p>

              <p>
                The launch attracted strong interest from publishers, media,
                educators, and readers, positioning {BRAND.domainLabel} as a
                forward-thinking space where young adults can express themselves
                authentically and safely.
              </p>

              <p>
                Through these initiatives, {BRAND.domainLabel} and The Buddyhood are
                not only championing diverse narratives, but also fostering
                meaningful dialogue between readers and the world around them.
                This marks an exciting new chapter in youth storytelling, one
                grounded in creativity, connection, and community.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintbooks;
